<template>
  <div>
      <Table :loading="loading" :columns="columns" :data="data" height="400">
        <template slot="action">
            
        </template>
      </Table>
      <div class="page-wrap">            
        <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
      </div>
    
  </div>
</template>
<script>
import RequestUtils from "@/utils/RequestUtils";
import conf from "@/views/im/conf";
export default {
  components: {
  },

  data() {
    return {
      loading: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'name',
      searchval: '',
      filter: {
        connector: 'lazada'
      },
      columns: [
          {
              title: '标题',
              key: 'title'
          },
          {
              title: '内容',
              key: 'content'
          },
          {
              title: '操作人',
              key: 'operator'
          },
          {
              title: '创建时间',
              key: 'create_time_text'
          },
          {
              title: 'Action',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },

  methods: {
    selectitem (key, value) {
      this.curPage = 1;
      this.filter[key] = value;
      this.request();
    },
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
    },
    // 构造请求参数
    buildparams () {
      let filter = JSON.parse(JSON.stringify(this.filter));
      if (this.searchval) {
        filter[this.searchfield] = this.searchval;
      }
      let param = new FormData();
      param.set("limit", this.pageSize);
      param.set("offset", (this.curPage-1)*this.pageSize );
      for (var key in filter) {
        param.set(key, filter[key]);
      }
      return param;
    },
    // 请求
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.getHostUrl()+'/aftersale/operationLog', self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.data;
        self.loading = false;
      })
    }
  },

  created() {
    let self = this;
    // this.request();
    window.addEventListener('message', function(e) {
        var data = e.data;
        console.log(data);
        if (data.event == 'refresh') {                
          self.request();
        } else if (data.event == 'error') {
            self.$Message.error(data.message);
        } else if (data.event == 'success') {
            self.request();
            self.$Message.success(data.message);
        }
    })  
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }

  
}
</style>
